<template>
  <div>
    <login-layout :title="layoutTit">
      <div class="invite-login-tit">
        {{ $t('message["638"]') }}
      </div>
      <div class="accout-login invite-login">
        <a-form
          :form="form"
          @submit.prevent="regHandle"
        >
          <a-form-item
            label=""
          >
            <a-input
              v-decorator="decorators.mobile"
              :placeholder="mobileTit"
              maxlength="11"
            />
          </a-form-item>
          <!-- <captcha-input /> -->
          <a-form-item
            label=""
            class="password-box"
          >
            <a-input
              v-decorator="decorators.checkcode"
              :placeholder="validTit"
              class="password-input"
            />
            <get-code
              class="find-pwd-link"
              type="11"
              :is-disabled="isDisabled"
              :mobile="form.getFieldValue('mobile')"
              @getRes="getRes"
            />
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
            >
              {{ $t('message["597"]') }}
            </a-button>
          </a-form-item>
        </a-form>
        <p class="ploy-tip">
          {{ $t('message["227"]') }} <a
            href="https://work.westartrack.com/page/service_pact.html"
            target="_blank"
          >{{ servicePactTxt[0] }}</a> {{ servicePactTxt[1] }} <a
            href="https://work.westartrack.com/page/privacy_pact.html"
            target="_blank"
          >{{ $t('message["1492"]') }}</a>
        </p>
      </div>
      <p class="reg-login-btn">
        {{ $t('message["1482"]') }}， <router-link :to="{name: 'AccountLogin'}">
          {{ $t('message["901"]') }}
        </router-link>
      </p>
      <is-reg-dialog
        ref="isRegDia"
        :auth="auth"
      />
    </login-layout>
  </div>
</template>
<script>
import GetCode from '@/components/pc/GetCode.vue'
import IsRegDialog from '@/components/pc/account/IsRegDialog'
import LoginLayout from '@/components/pc/account/LoginLayout'
// import CaptchaInput from '@/components/pc/CaptchaInput.vue'
import { mapState, mapActions } from 'vuex'

export default {
  'name': 'Register',
  components: {
    GetCode,
    IsRegDialog,
    LoginLayout
  },
  data () {
    return {
      isDisabled: false,
      auth: '',
      inviteLogin: {
        mobile: '',
        checkuserid: '',
        checkcode: ''
      },
      checkuserid: '',
      getCodeUrl2: '',
      formLayout: 'horizontal'
      // captcha: '',
      // captchaUrl: `${CAPTCHA_URL}?t=${Date.now()}`
    }
  },
  computed: {
    ...mapState('account/register', ['submitting', 'decorators']),
    servicePactTxt () {
      return this.$t('message["314"]').split('|')
    },
    mobileTit () {
      return this.$t('message["1112"]')
    },
    layoutTit () {
      return this.$t('message["1381"]')
    },
    validTit () {
      return this.$t('message["1433"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  async mounted () {
    // this.refreshCaptcha()
  },
  methods: {
    ...mapActions('account/register', ['register']),
    regHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const obj = Object.assign(values, { checkuserid: this.checkuserid })
          const chain = await this.register()
          chain.params(obj)
            .onSuccess(raw => {
              if (raw.isreg === 1) {
                this.auth = raw.Authorization
                this.$refs.isRegDia.changeLimitDialog(true)
              } else {
                this.$router.push({ name: 'AccountSetUser', query: { mobile: this.form.getFieldValue('mobile'), ensecret: raw.ensecret } })
              }
            })
            .setForm(this.form)
            .fetch()
        }
      })
    },
    inputChange () {
      this.isDisabled = false
    },
    getRes (payload) {
      this.checkuserid = payload.checkuserid
    }
  }
}
</script>

<style lang="scss" >
.invite-login-tit {
  height: 24px;
  line-height: 24px;
  font-weight: bold;
  text-align: center;

  span {
    margin: 0 10px;
  }
}

.invite-login {
  padding-top: 30px;

  .login-btn {
    display: block;
    width: 100%;
  }

  .password-box {
    position: relative;

    .find-pwd-link {
      position: absolute;
      right: 0;

      button {
        background: none;
        border: 0;
        color: #5077aa;
        padding: 0;
      }

      .is-disabled {
        color: #c0c4df;
        background: none;
      }
    }
  }
}

.reg-login-btn {
  text-align: center;
  padding-bottom: 20px;
}
.ploy-tip {
  color: #b3b3b3;
  margin-bottom: 32px;
}
</style>
